import { useEffect, useState } from "react";
import { useApi } from "../../utils/Api";
import DigitalPermitView from "../../components/digital-licenses/DigitalPermitView";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Translate from "../../utils/Translate";
import Preloader from "../../components/Preloader";
import FeatureBox from "../../components/digital-licenses/FeatureBox";
import { accessKeys, hasAccess } from "../../utils/userAccess";
import { androidAppUrl, iosAppUrl } from "../../utils/constants";
import { detectBrowser, detectDevice } from "../../utils/device";
import { Button } from "@mui/material";

export default function DigitalPermitListPage(props) {
  const { id: machine } = useParams();
  const [permits, setPermits] = useState([]);
  const [allPermits, setAllPermits] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState("allItems");
  const [selectedCompany, setSelectedCompany] = useState("allItems");
  const [isLoading, setIsLoading] = useState(false);
  const api = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    async function loadPermits() {
      setIsLoading(true);
      const response = await api.fetch(`${import.meta.env.VITE_MAIN_URL}v1/digital/permits`, false, "GET");
      if (response.isSuccessful) {
        setAllPermits(response.permits);
        if (machine) {
          setSelectedMachine(machine);
          setFilter(machine, "machineGroups");
          const filtered = response.permits.filter((x) => x.skillGroupDescription === machine);
          setPermits(filtered);
        } else {
          setPermits(response.permits);
        }
      }
      setIsLoading(false);
    }

    loadPermits();
  }, [api]);
  const setFilter = (filter, target) => {
    let filtered = allPermits;
    if (target === "machineGroups") {
      setSelectedMachine(filter);
      if (filter !== "allItems") {
        filtered = filtered.filter((x) => x.skillGroupDescription === filter);
      }
      if (selectedCompany !== "allItems") {
        filtered = filtered.filter((x) => x.parentActorName === selectedCompany);
      }
    }
    if (target === "Companies") {
      setSelectedCompany(filter);
      if (filter !== "allItems") {
        filtered = filtered.filter((x) => x.parentActorName === filter);
      }
      if (selectedMachine !== "allItems") {
        filtered = filtered.filter((x) => x.skillGroupDescription === selectedMachine);
      }
    }
    setPermits(filtered);
  };

  function getAppUrl() {
    const device = detectDevice();
    switch (device) {
      case "ios":
        return iosAppUrl;
      case "android":
        return androidAppUrl;
      case "desktop":
      default:
        const browser = detectBrowser();
        return browser === "safari" ? iosAppUrl : androidAppUrl;
    }
  }

  return (
    <>
      {isLoading && <Preloader />}
      <div className="dlWrapper">
        <div className="dlFilter">
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>{Translate.get("MachineGroups")}</InputLabel>
            <Select
              value={selectedMachine}
              label={Translate.get("MachineGroups")}
              onChange={(event) => setFilter(event.target.value, "machineGroups")}
            >
              <MenuItem value={"allItems"}>{Translate.get("ShowAll")}</MenuItem>
              {allPermits &&
                [...new Set(allPermits.map((item) => item.skillGroupDescription))].map((val, index) => (
                  <MenuItem key={index} value={val}>
                    {val}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>{Translate.get("Company")}</InputLabel>
            <Select
              value={selectedCompany}
              label={Translate.get("Company")}
              onChange={(event) => setFilter(event.target.value, "Companies")}
            >
              <MenuItem value={"allItems"}>{Translate.get("ShowAll")}</MenuItem>
              {allPermits &&
                [...new Set(allPermits.map((item) => item.parentActorName))].map((val, index) => (
                  <MenuItem key={index} value={val}>
                    {val}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>

        {permits &&
          permits.length > 0 &&
          permits.map((permit) => (
            <DigitalPermitView
              key={permit.actorPermitId}
              permit={permit}
              onClick={() => navigate(`/d/permits/${permit.actorPermitId}`)}
            />
          ))}

        {!isLoading && permits && permits.length === 0 && (
          <div className="dlcNoDataContainer withBottomContent">
            <img src="/static/no-data-empty-box.svg" alt="" />
          </div>
        )}

        {hasAccess(accessKeys.digitalLicensesHolder) && (
          <div className="dlcFeatureBoxesContainerPermits">
            <FeatureBox
              color="#F05032"
              title={Translate.get("ECompAppInfoTitle")}
              description={Translate.get("ECompAppInfoDescription")}
              imgSrc="/static/app-info.png"
              imgClassName="dlcFeatureBoxAppImage"
              buttonComponent={
                detectDevice() === "desktop" ? (
                  <a href={iosAppUrl} target="_blank" rel="noopener noreferrer">
                    <img src="https://eportpublic.blob.core.windows.net/others/apple/get_on_apple_store_SE.svg?sp=r&st=2024-04-12T07:06:58Z&se=2064-04-12T15:06:58Z&spr=https&sv=2022-11-02&sr=c&sig=STfImuoPxA9srWpHhIHlMAaW7w9ST8G1CYcpsinC6PQ%3D" />
                  </a>
                ) : (
                  <Button
                    component="a"
                    href={getAppUrl()}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    color="error"
                  >
                    {Translate.get("ECompAppInfoButtonLabel")}
                  </Button>
                )
              }
              extraButtonComponent={
                detectDevice() === "desktop" ? (
                  <a href={androidAppUrl} target="_blank" rel="noopener noreferrer">
                    <img src="https://eportpublic.blob.core.windows.net/others/google/get_on_google_play_SE.png?sp=r&st=2024-04-12T07:06:58Z&se=2064-04-12T15:06:58Z&spr=https&sv=2022-11-02&sr=c&sig=STfImuoPxA9srWpHhIHlMAaW7w9ST8G1CYcpsinC6PQ%3D" />
                  </a>
                ) : null
              }
            />
          </div>
        )}
      </div>
    </>
  );
}
